<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="brand-logo"><a class="navbar-brand"><img src="../../assets/images/entain_logo.svg"> | GMS</a>
  </div>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>


  <!-- <ul class="navbar-nav">
<li class="nav-item">
  <a class="nav-link"
    [routerLink]="['/welcome']"
  routerLinkActive="active">Home</a>
</li> -->

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      @for (menuItem of getMenusData(); track menuItem) {
      <li class="nav-item">
        <a class="nav-link" [routerLink]="[navlinksData[menuItem].address]"
          routerLinkActive="active">{{navlinksData[menuItem].name}} </a>
      </li>
      }
      <!-- <li class="nav-item">
    <a class="nav-link" [routerLink]="['./gamemanagement']" routerLinkActive="active">GAME
    MANAGEMENT</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [routerLink]="['./chatmanagement']" routerLinkActive="active">CHAT
    MANAGEMENT</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [routerLink]="['./datareports']" routerLinkActive="active">DATA AND REPORTS</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [routerLink]="['./customerservices']" routerLinkActive="active">CUSTOMER
    SERVICES</a>
  </li> -->
    </ul>

  </div>
  <div>
    <app-gms-logout></app-gms-logout>
  </div>

</nav>
<router-outlet></router-outlet>